<template>
  <!-- READ ONLY MODE -->
  <div v-if="mode == 'VIEW'" class="pt-10 pb-10 clearfix log-entry">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <table class="input-text table table-bordered" width="100%" border="1">
      <thead>
        <tr>
          <th class="text-left table-border-header" v-for="each in question.entries" :key="each.header">
            {{ each.header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-left table-border-bottom" v-for="each in question.entries" :key="each.label">
            {{ each.label }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- PHONE VIEW -->
  <div v-else-if="mode == 'PHONE'">
    <div class="modal bs-example-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title" v-html="question.formattedBody" />
          </div>
          <div class="modal-body"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->
  <div v-else-if="mode == 'EDIT'" class="p-0 pt-10 pb-10 clearfix log-entry">
    <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
      <span
        class="add-help-text"
        :class="{
          'right-position': activityDetails.customParticipantMessaging
        }"
        :style="{
          color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
        }"
      >
        Add Help
      </span>
    </div>
    <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
      <span
        class="add-help-text"
        :style="{
          color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
        }"
      >
        Add Message
      </span>
    </div>

    <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="editorOptionForQuestion"></quill-editor>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-40 mb-10" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
    <div class="pl-0 mt-15">
      <h5 v-if="question.type">Answer</h5>
      <div class="row form-group pt-3">
        <div class="col-lg-3 p-0 mb-15 column_input" v-for="entry in question.entries" :key="entry.sequence">
          <input type="text" class="form-control input-style" :maxlength="35" placeholder="Enter header" v-model="entry.header" />
          <button class="btn btn-link color_red p-0" v-if="question.entries.length > 1">
            <img class="mt-6 mr-5 p-0" v-on:click="deleteLogEntryColumn(entry)" src="static/img/delete.svg" />
          </button>
          <input type="text" class="form-control input-style" :maxlength="35" placeholder="Enter Label" v-model="entry.label" />
        </div>
        <div class="col-lg-3">
          <div class="add_another_answer mt-40">
            <a href="javascript:void(0);" v-on:click="addAnotherLogEntry()">Add another column</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";
import _ from "lodash";

export default {
  name: "ActivityStepLog",
  mixins: [activityStepCustomMessage],
  components: {
    quillEditor
  },
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  data() {
    return {
      entries: [],
      logEntryInfoDiv: false,
      editorOptionForQuestion: {
        placeholder: "Enter question",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      isAddHelpEnabled: false
    };
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    addAnotherLogEntry() {
      if (!this.question.entries) {
        this.question.entries = [];
      }
      let maxSequence = Number(_.max(_.map(this.question.entries, "sequence")));
      if (!maxSequence) {
        maxSequence = this.question.entries.length;
      }
      this.question.entries.push({
        header: null,
        sequence: maxSequence + 1
      });
      this.$forceUpdate();
    },
    deleteLogEntryColumn(option) {
      if (this.question.entries.indexOf(option) > -1) {
        this.question.entries.splice(this.question.entries.indexOf(option), 1);
      }
      this.$forceUpdate();
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };

      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        return false;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      _.forEach(question.entries, entry => {
        const body = this.stripHtml(entry.header);
        if (body.length == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Header is required.";
          return errorObj;
        }

        if (body && body.length > 512) {
          errorObj.isValid = false;
          errorObj.msg = "Character limit reached.";
          return errorObj;
        }
        if (!entry.header) {
          errorObj.isValid = false;
          errorObj.msg = "Header is required";
          return errorObj;
        }
        const uniqueOptionsArr = _.uniqBy(question.entries, "header");
        if (uniqueOptionsArr.length < question.entries.length) {
          errorObj.isValid = false;
          errorObj.msg = "Please populate all required fields and make sure answer options are not identical.";
          return errorObj;
        }
      });

      if (!errorObj.isValid) {
        return errorObj;
      }

      if (!question.hasOwnProperty("entries")) {
        errorObj.isValid = false;
        errorObj.msg = "Answer is required.";
        return errorObj;
      }

      return {
        isValid: Boolean(question.formattedBody && question.sequence && question.entries.length > 0)
      };
    }
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  }
};
</script>
<style lang="scss">
.log-entry {
  .fa,
  .far,
  .fas {
    font-family: "FontAwesome";
  }
  .score_cls {
    margin-left: -3%;
  }
}
table.input-text th {
  background: #e4e8eb;
  padding: 7px;
  border-radius: 2px;
}
.col-md-12 .col-md-12 .activity-configurator-step-view-mode .input-text.table {
  width: 690px;
}
.activity-configurator-step-view-mode table.input-text.table-bordered td {
  background: #fff;
  padding: 0.4rem 0.4rem;
  height: 34.21px;
  border: 2px solid #dee2e6;
}
.table-bordered td {
  border: none;
}
.form-control {
  border-radius: 0.1rem;
}
.row_input,
.column_input {
  position: relative;
}
.row_input .btn.btn-link.color_red,
.column_input .btn.btn-link.color_red {
  position: absolute;
  top: 0;
  right: 0;
}
.row_input .btn.btn-link.color_red img,
.column_input .btn.btn-link.color_red img {
  width: 19px;
  height: 20px;
}
.table-border-header {
  border: 3px solid #dee2e6 !important;
}
.table-border-bottom {
  border: 3px solid #dee2e6 !important;
}
.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -8px;

  &.right-position {
    right: 637px;
  }
}
</style>
